import React from 'react'
import ReactDOM from 'react-dom/client'

import { initMonitoring } from '@/lib/monitoring'
import { App } from '@/app/App'
import '@/styles/index.css'

initMonitoring()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
